module.exports = __webpack_public_path__ + "static/3-058d0127911a63677cb407d9070bfdaf.jpg";